import React, {useEffect, useState, useRef} from "react";
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css';
import 'react-quill-new/dist/quill.snow.css';
import {toast} from "react-toastify";
import axios from "axios";
import {API_BASE_URL} from "../../config";
import {useParams} from "react-router-dom";
import CommentWithImageModal from "./CommentWithImageModal";
import {formatDateBeautiful} from "../../utils/dateUtils";
import 'quill-mention';
import 'quill-mention/dist/quill.mention.css';
import CommentInput from "./TiptapEditor";
// Function to style mentions

const CommentsSection = ({comments, onReply, replyTo, newCommentTrigger, triggerAssignedUsers}) => {
    const currentUser = localStorage.user_name;
    const {id} = useParams();

    // State for the reply comment
    const [comment, setComment] = useState('');
    const quillRef = useRef(null);
    const selectionRef = useRef(null); // To store the cursor selection

    // State for editing an existing comment
    const [editingCommentId, setEditingCommentId] = useState(null);
    const [editingCommentContent, setEditingCommentContent] = useState("");

    const [mentionUsers, setMentionUsers] = useState([]);

    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_users_quill`, {})
            .then(res => {
                const formatted = res.data.map(user => ({
                    id: user.id,  // or user.id if available
                    value: user.username,
                }));
                console.log(formatted)
                setMentionUsers(formatted);
            })
            .catch(err => {
                console.error('Error fetching mention users:', err);
            });
    }, []);

    // Restore selection after comment state update
    useEffect(() => {
        if (quillRef.current && typeof quillRef.current.getEditor === "function" && selectionRef.current) {
            setTimeout(() => {
                try {
                    const editor = quillRef.current.getEditor();
                    if (editor && typeof editor.setSelection === "function") {
                        editor.setSelection(selectionRef.current);
                    }
                } catch (err) {
                    console.warn("Editor instance not ready for selection restore", err);
                }
            }, 50);
        }
    }, [comment]);

    const handleReply = (commentary) => {
        onReply(commentary);
        //if (commentary.username !== null) setComment(`@${commentary.username} `);
    };

    const saveComment = () => {
        if (!comment) {
            toast.error("Le commentaire ne peut pas être vide");
            return;
        }
        const user_id = localStorage.getItem("user_id");
        axios.post(`${API_BASE_URL}/save_comment_ticket`, {
            id, user: user_id, comment, reply_to: replyTo,
        })
            .then((res) => {
                setComment("");
                newCommentTrigger();
                toast.success("Commentaire ajouté avec succès");
            })
            .catch((error) => {
                console.error("Error saving comment:", error);
                toast.error("Impossible d'ajouter le commentaire");
            });
    };

    // Handler to enter edit mode for a comment
    const handleEdit = (commentary) => {
        setEditingCommentId(commentary.id);
        setEditingCommentContent(commentary.content);
    };

    const saveEditedComment = () => {
        if (!editingCommentContent) {
            toast.error("Le commentaire ne peut pas être vide");
            return;
        }
        const user_id = localStorage.getItem("user_id");
        axios.post(`${API_BASE_URL}/edit_comment_ticket`, {
            id: editingCommentId, user: user_id, comment: editingCommentContent, reply_to: replyTo,
        })
            .then((res) => {
                setEditingCommentId(null);
                setEditingCommentContent("");
                newCommentTrigger();
                toast.success("Commentaire édité avec succès");
            })
            .catch((error) => {
                console.error("Error editing comment:", error);
                toast.error("Impossible d'éditer le commentaire");
            });
    };

    const cancelEdit = () => {
        setEditingCommentId(null);
        setEditingCommentContent("");
    };

    const handleCommentChange = (html) => {
        setEditingCommentContent(html);

        const matches = [...html.matchAll(/@\[[^\]]+\]\((\d+)\)/g)];
        if (matches.length > 0) {
            const lastMentionedId = matches[matches.length - 1][1];
            console.log("Mentioned user in edited comment:", lastMentionedId);
            // Optional: set state or trigger an effect
            triggerAssignedUsers()
        }
    };

    // Function for grouping main comments and replies
    const groupComments = (comments) => {
        const mainComments = comments.filter((comment) => !comment.comment_to);
        const sortedMainComments = [...mainComments].sort((a, b) => new Date(b.date) - new Date(a.date));
        const grouped = {};
        sortedMainComments.forEach((comment) => {
            grouped[comment.id] = {commentary: comment, replies: []};
        });
        comments.forEach((comment) => {
            if (comment.comment_to && grouped[comment.comment_to]) {
                grouped[comment.comment_to].replies.push(comment);
            }
        });
        return sortedMainComments.map((comment) => grouped[comment.id]);
    };

    const groupedComments = groupComments(comments);

    return (<div className="mb-20">
        {groupedComments.map(({commentary, replies}) => (<div key={commentary.id} className={"mb-20"}>
            <div className={"display-flex h-100 gap-20 "}>
                <div className={"border-radius-round h-100"}>
                    <span className={"display-flex align-items-center justify-content-center"}>
                        <div className={"border-radius-round h-100 mt-10"}
                             style={{backgroundColor: commentary.color ? commentary.color : '#dedede'}}>
                                <span className={"display-flex align-items-center justify-content-center"}
                                      style={{height: 40, width: 40}}>
                            {commentary.username_display && <strong style={{fontSize: ".8rem"}}>
                                {(commentary?.username_display && commentary.username_display.split(' ').map(word => word[0]).join('')) || comment.username}
                            </strong>}
                            </span>

                        </div>
                    </span>
                </div>

                <div className={"comment-section-width"}>

                    <div
                        className="ticket-comment display-flex flex-direction-column justify-content-space-between p-0 comment-top-bar">

                        {editingCommentId === commentary.id ? (
                            <CommentInput
                                triggerAssignedUsers={triggerAssignedUsers} value={editingCommentContent} onChange={handleCommentChange}
                            />) : (<div
                            className="comment comment-img"
                            style={{padding: '20px'}}
                            dangerouslySetInnerHTML={{__html: commentary.content}}
                        />)}


                        <div className="comment display-flex flex-direction-row justify-content-space-between"
                             style={{borderTop: "solid 1px #ddd"}}>
                            <div className="p-10">
                                <strong>
                                    <span dangerouslySetInnerHTML={{__html: commentary.username_display}}/>
                                </strong>
                                {commentary.author === -1 && <strong>
                                    <span>Client</span>
                                </strong>}
                                &nbsp;le&nbsp;
                                <span>{new Date(commentary.date).toLocaleString()}</span>
                                {!commentary.edit_date && (<>
                                        <span style={{fontSize: "1.2rem"}} className="mx-10">
                                            ⸱
                                        </span>
                                    Modifié le <span>{formatDateBeautiful(commentary.edit_date)}</span>
                                </>)}
                            </div>
                            <div className="actions display-flex flex-direction-row align-items-center">
                                {currentUser === commentary.username && editingCommentId !== commentary.id && (<button
                                    title="Editer le commentaire"
                                    className="edit-button"
                                    onClick={() => handleEdit(commentary)}
                                    style={{marginRight: "5px"}}
                                >
                                    <i className="fa-solid fa-edit"/>
                                </button>)}
                                {editingCommentId === commentary.id && (<div className={""}>
                                    <button
                                        className={"cursor-pointer"}
                                        title="Sauvegarder l'édition"
                                        onClick={saveEditedComment}
                                        style={{marginRight: "5px"}}
                                    >
                                        Sauvegarder
                                    </button>
                                    <button
                                        className={"cursor-pointer"}
                                        style={{marginRight: 5}}
                                        title="Annuler l'édition"
                                        onClick={cancelEdit}
                                    >
                                        Annuler
                                    </button>
                                </div>)}
                                <button
                                    title={`Répondre à ${commentary.username}`}
                                    className="reply-button"
                                    onClick={() => handleReply(commentary)}
                                >
                                    <i className="fa-solid fa-arrow-turn-down-left color-third"/>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {replies.map((reply) => (<CommentWithImageModal
                key={reply.id}
                currentUser={currentUser}
                reply={reply}
            />))}

            {replyTo === commentary.id && (<div className="ticket-resolution-notes display-flex"
                                                style={{
                                                    alignItems: "flex-end", flexDirection: "column-reverse"
                                                }}>
                <div className="display-flex flex-direction-column" style={{width: "75%"}}>
                    <CommentInput value={comment} onChange={(e) => setComment(e.target.value)}

                                  triggerAssignedUsers={triggerAssignedUsers}/>

                    <button className="button-third"
                            style={{zIndex: 9, marginLeft: 0}}
                            onClick={saveComment}>
                        Répondre
                    </button>
                </div>
            </div>)}
        </div>))}
    </div>);
};

export default CommentsSection;
